
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDIcon from '../../BaseComponents/Icon/EDIcon';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import { IconType } from '../../BaseComponents/Icon/Utils/IconDefinitions';
import EDView from '../../BaseComponents/View/EDView';
import classNames from 'classnames';

interface IProps {
  errorText: React.ReactNode;
  icon?: IconType;
  iconNode?: React.ReactNode;
  children?: React.ReactNode;
  notFullPage?: boolean;
  errorTextColor?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fullPage: {
    minHeight: `calc(100vh - ${theme.spacing(24)})`,
  },
  content: {
    textAlign: 'center',
  },
  text: {
    color: theme.customProperties.Fade.DarkOnLight.mediumEmphasis,
  },
  errorText: {
    color: theme.palette.error.main,
    fontWeight: 'bold',
  },
});

/**
   * Ett meddelande som visas istället för en sida med data om det inte går att visa datat för att t.ex. användaren inte gjort ett urval, valt analys eller liknande.
      Är inte tänkt för programfel
   */
export const DataErrorPage: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, errorText, children, errorTextColor } = props;

  return (
    <div
      className={classNames(classes.root, {
        [classes.fullPage]: !props.notFullPage,
      })}
    >
      <div className={classes.content}>
        {props.icon && (
          <EDIcon
            iconType={props.icon}
            size="large"
            marginBottom={1}
            color={'lowEmphasis'}
          />
        )}
        {props.iconNode}
        <EDTypography
          className={classNames(classes.text, {
            [classes.errorText]: errorTextColor,
          })}
          component="h2"
        >
          {errorText}
        </EDTypography>
        <EDView>{children}</EDView>
      </div>
    </div>
  );
};

export default withStyles(DataErrorPage, styles);
